import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../styleSheets/about.css";
import "../styleSheets/buttons.css";

function About() {
  const navigate = useNavigate();
  const { t } = useTranslation("common");

  function aboutButton() {
    navigate("/AboutFull", { state: null });
  }

  return (
    <section className="section-about" aria-labelledby="about-home-title">
      <div className="container-about">
        <div className="photos-container">
          <div className="photo-family-frame">
            <div className="family-image" />
          </div>
          <div className="photo-dad_and_me-frame">
            <div className="dad_and_me-image" />
          </div>
        </div>
        <div className="message-area-container">
          <div className="message-text-area">
            <h2 id="about-home-title" className="message-title">
              {t("pageBody.about.moreThanAMessage")}
            </h2>
            <div className="divider" />
            <div className="message-text">
              {t("pageBody.about.homePageText")}
            </div>
          </div>
          <button type="button" className="btn btn--white btn--size-lg" onClick={aboutButton}>
            {t("footer.menu.aboutUs")}
          </button>
        </div>
      </div>
    </section>
  );
}

export default About;
